import React, { useState, useEffect } from 'react';

import Box from '@mui/material/Box';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import PersonIcon from '@mui/icons-material/Person';
import EmailIcon from '@mui/icons-material/AlternateEmail';
import EditIcon from '@mui/icons-material/Edit';
import AccessibilityIcon from '@mui/icons-material/Accessibility';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import CardActionArea from '@mui/material/CardActionArea';


import { SCHEMA_PROFILES_URL } from '@src/config';
import useCallApi from '@src/hooks/useCallApi';
import Page from '@src/components/Page';
import useLocalStorage from '@src/hooks/useLocalStorage';

const SELECTED_PROFILE_STORAGE_KEY = `ALM_${SCHEMA_PROFILES_URL}_profile`


function useProfiles() {
  const [ selectedProfileId, setSelectedProfileId ] = useLocalStorage(
    '', SELECTED_PROFILE_STORAGE_KEY
  );
  const [ profiles, setProfiles ] = useState();
  useEffect(() => {
    if (SCHEMA_PROFILES_URL) {
      const getProfiles = async () => {
        const resp = await fetch(SCHEMA_PROFILES_URL, {
          headers: {
            'Cache-Control': 'no-cache'
          },
        });
        const res = await resp.json();
        setProfiles(res);
      };
      getProfiles();
    } else {
      setProfiles([{
        "id": "default",
        "name": "Par défaut",
      }]);
    }
  }, []);

  return [ profiles, selectedProfileId, setSelectedProfileId ];
}


export default function Account() {
  const user = useCallApi('/user');
  const [ profiles, selectedProfileId, setSelectedProfileId ] = useProfiles();
  const activeProfile = profiles?.length ? (
    profiles.find(p => p.id == selectedProfileId) ?? profiles[0]
  ) : null;
  return (
    <Page
      title={
        <Typography variant="h1">
          Mon compte
        </Typography>
      }
    >
      <List>
        <ListItem>
          <ListItemIcon>
            <PersonIcon/>
          </ListItemIcon>
          <ListItemText>
            {user?.name || ''}
          </ListItemText>
        </ListItem>
        <ListItem>
          <ListItemIcon>
            <EmailIcon/>
          </ListItemIcon>
          <ListItemText>
            {user?.email || ''}
          </ListItemText>
        </ListItem>
        {user?.auth_provider ? (
          <ListItem>
            <ListItemButton component="a" href={user.auth_provider + '/account'} disableGutters>
              <ListItemIcon>
                <EditIcon/>
              </ListItemIcon>
              <ListItemText>
                Gérer mon compte
              </ListItemText>
            </ListItemButton>
          </ListItem>
        ) : null}
        {profiles ? (
          <ListItem>
            <Stack spacing={2}>
              <Stack direction="row">
                <ListItemIcon>
                  <AccessibilityIcon/>
                </ListItemIcon>
                <ListItemText>
                  Profil de collecte
                </ListItemText>
              </Stack>
              <Box
                sx={{
                  width: '100%',
                  display: 'grid',
                  gridTemplateColumns: 'repeat(auto-fill, minmax(min(200px, 100%), 1fr))',
                  gap: 2,
                }}
              >
                {profiles.map(({ id, name, description }) => (
                  <Card variant="outlined" key={id}>
                    <CardActionArea
                      onClick={() => setSelectedProfileId(id)}
                      data-active={activeProfile.id === id ? '' : undefined}
                      sx={{
                        height: '100%',
                        padding: '2px',
                        '&[data-active]': {
                          padding: '0px',
                          color: 'primary.main',
                          borderStyle: 'none',
                          borderWidth: '2px',
                          borderStyle: 'solid',
                          borderColor: 'primary.main',
                          '&:hover': {
                            backgroundColor: 'action.selectedHover',
                          },
                        },
                      }}
                    >
                      <CardContent sx={{ height: '100%' }}>
                        <Typography variant="h5" component="div">
                          {name}
                        </Typography>
                        <Typography variant="body2" color="text.secondary">
                          {description}
                        </Typography>
                      </CardContent>
                    </CardActionArea>
                  </Card>
                ))}
              </Box>
            </Stack>
          </ListItem>
        ) : null}
      </List>
    </Page>
  );
}
